// extracted by mini-css-extract-plugin
export default {"tab":"style_tab__6Y7HQ","tab_selected":"style_tab_selected__EdKiV","tabList":"style_tabList__4SaW8"};